export default "__VITE_ASSET__2801085d__"